<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null" class="input-field">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" [ngClass]="teamStatusIcon" role="img"></span>
    }
    {{ label | translate }}
  </mat-label>

  <input
    matInput
    [formControl]="control"
    [errorStateMatcher]="this"
    spellcheck="false"
    [matAutocomplete]="auto"
    [readonly]="isDisabled"
    required
    autocomplete="off"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" class="mat-autocomplete-user-items">
    @for (option of filteredOptions; track option) {
      <mat-optgroup [ngClass]="{ 'empty-group-item': !option.name }">
        @if (!!option.name) {
          <div class="mat-group-option-user-item">
            @if (!option.disabled) {
              <nimbus-avatar
                class="user-image"
                [imageSrc]="option.isService ? nimbusServiceImagePath : (option.imageSafeUrl$ | async)"
                [name]="option.name"
                [initials]="option.initials"
              ></nimbus-avatar>
            }
            <div class="user-information">
              <div class="user-name">
                <nimbus-tooltip [text]="option.name"></nimbus-tooltip>
                {{ option.name }}
              </div>
            </div>
          </div>
        }
        @for (callOption of option.callOptions; track callOption) {
          <mat-option
            class="user-autocomplete-mat-option"
            [value]="callOption"
            [disabled]="option.disabled || isCallOptionDisabled(callOption)"
            [ngClass]="{ 'empty-user-details': callOption.type === UserAutoCompleteCallOptionType.not_found }"
          >
            <div class="mat-option-user-details">
              @if (!option.disabled && option.isPSTN) {
                <nimbus-avatar
                  class="user-image"
                  [imageSrc]="option.image"
                  [name]="callOption.text"
                  [initials]="option.initials"
                ></nimbus-avatar>
              }
              @if (!option.isPSTN && callOption.icon) {
                <i [nimbusIcon]="getCallOptionIcon(callOption)" class="call-option"> </i>
              }
              <span class="mat-option-user-text">
                <nimbus-tooltip [text]="callOption.text"></nimbus-tooltip>
                {{ callOption.text }}
              </span>
            </div>
          </mat-option>
        }
      </mat-optgroup>
    }
  </mat-autocomplete>
  <ng-container matSuffix>
    <ng-content></ng-content>
  </ng-container>
  @if (isInvalidAutocomplete && isInvalidPhoneNumber) {
    <i matSuffix class="info-suffix">
      <nimbus-mat-icon-overlay [icon]="icons.EXCLAMATION_TRIANGLE">
        {{ TranslationKeys.PhoneNumberNormalizationPopupInfoMessage | translate }}
      </nimbus-mat-icon-overlay>
    </i>
  }
  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }
  @if (!isDisabled && value) {
    <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CLOSE_LIGHT" (click)="onClearValueClick($event)"></i>
  }

  @if (isInvalidAutocomplete) {
    <mat-error>
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }
</mat-form-field>
